export default "__VITE_ASSET__CiyLxSU3__"